import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import useFormInput from "../../hooks/useFormInput";
import { changeName } from '../javascript/function';

const NameModal = (props) =>
{


  const cname = useFormInput("");

    return(<div>
  
        <Modal open={props.open} onClose={props.onCloseModal} center classNames={{
          modal: 'customModal',
        }}>
         <div className='modal-header'><h3 className='modal-title'>Change Name</h3></div>
         <div className='modal-body'> 
         <form className="mt-1" style={{minWidth:"320px"}}  onSubmit={(event)=> { event.preventDefault();changeName(props.OEM,cname.value);props.onCloseModal();}}>
                      <div className="form-group">
                      <input
                          type="text"
                          className="form-control mb-0"
                          id="cname"
                          name="cname"
                          placeholder={props.currentName}
                          {...cname}
                          autoComplete="off"
                          required
                         
                        />
                      </div>

                   
                      <div className="sign-info">
                        {/*   <div className="custom-control custom-checkbox d-inline-block">
                        <input type="checkbox" className="custom-control-input" id="customCheck" />
                        <label className="custom-control-label" htmlFor="customCheck">Remember Me</label>
                     
                     
                     </div>     */}
                        <button
                          type="submit"
                          className="btn btn-hover"
                          style={{ float: "right" }}
                        >
                          Change Name
                        </button>
                      </div>
                    </form>
         </div>
      
        </Modal>
      </div>);

    
}

export default NameModal